import { render, staticRenderFns } from "./AddCompany.vue?vue&type=template&id=63043190&scoped=true&"
import script from "./AddCompany.vue?vue&type=script&lang=js&"
export * from "./AddCompany.vue?vue&type=script&lang=js&"
import style0 from "./AddCompany.vue?vue&type=style&index=0&id=63043190&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63043190",
  null
  
)

component.options.__file = "AddCompany.vue"
export default component.exports